import * as React from 'react';
import { observable, action } from 'mobx';
import { inject, observer } from 'mobx-react';
import { FormState, FieldState } from 'formstate';

// Constants
import { ROUTE_PATHS } from '../../constants/routes';

// Types
import { IStore } from '../../store/Store';

// Utilities
import { required, between } from '../../utilities/validation';

// Services
import { resetPassword } from '../../services/auth';

// Components
import Box from '../../components/Box';
import Button from '../../components/Button';
import { AlertDialog } from '../../components/Dialog';
import { EntryLayout } from '../../components/Layout';
import Grid from '../../components/Grid';
import { Form, TextField } from '../../components/FormStateFields';
import Typography from '../../components/Typography';

// FormState
class LoginForm {
  password = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(4, 32));

  state = new FormState({
    password: this.password
  });

  gerValues() {
    return {
      password: this.password.$
    };
  }
}

// Component
interface IProps {
  store?: IStore;
  query: { secret: string; id: string };
}
class Login extends React.Component<IProps, {}> {
  form = new LoginForm();

  @observable
  alertDialogState = {
    open: false,
    title: '',
    description: ''
  };

  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const validation = await this.form.state.validate();

    if (validation.hasError === false) {
      try {
        await await resetPassword({
          query: this.props.query,
          body: {
            password: this.form.password.$
          }
        });
        this.handleSuccessDialogOpen();
      } catch (error) {
        this.handleErrorDialogOpen();
      }
    }
  };

  @action
  handleSuccessDialogOpen = () => {
    this.alertDialogState = {
      open: true,
      title: 'Password has been reset',
      description:
        'Your password has benn successfully reset. You can now login with you new password.'
    };
  };

  @action
  handleErrorDialogOpen = () => {
    this.alertDialogState = {
      open: true,
      title: 'Incorrect reset link',
      description:
        'Something seams to be wrong with the link. Please try to reset you password again.'
    };
  };

  handleDialogConfirm = () => {
    this.props.store!.routerStore!.navigate(ROUTE_PATHS.LOGIN);
  };

  handleErrorDialogClose = () => {
    this.alertDialogState.open = false;
  };

  render() {
    return (
      <EntryLayout>
        <Form onSubmit={this.handleSubmit}>
          <Box px={3} pt={3}>
            <Typography type="headline" align="center">
              Reset Password
            </Typography>
            <Typography type="body1" align="center" color="textSecondary">
              Change your password and continue.
            </Typography>
            <TextField
              label="Password"
              type="password"
              fieldState={this.form.password}
              margin="normal"
              fullWidth={true}
            />
            <br />
            <br />
            <Grid container={true} justify="space-between" alignItems="center">
              <Grid item={true} xs={12}>
                <Button
                  raised={true}
                  color="primary"
                  type="submit"
                  style={{ width: '100%' }}
                >
                  Set password
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Form>
        <AlertDialog
          state={this.alertDialogState}
          onClose={this.handleErrorDialogClose}
          onConfirm={this.handleDialogConfirm}
        />
      </EntryLayout>
    );
  }
}

export default inject('store')(observer(Login));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Reset/Reset.tsx